export const CLASS_STYLES = {
  "strong match": "bg-[hsl(var(--gold))]/20 text-[hsl(38,70%,32%)] border-[hsl(var(--gold))]/40",
  "potential match": "bg-[hsl(var(--teal))]/15 text-[hsl(var(--teal))] border-[hsl(var(--teal))]/30",
  "transferable-skills match": "bg-blue-50 text-blue-700 border-blue-200",
  "insufficient information": "bg-slate-100 text-slate-600 border-slate-200",
  "missing mandatory qualification": "bg-red-50 text-red-700 border-red-200",
  "human review required": "bg-amber-50 text-amber-700 border-amber-200",
};

export const STATUSES = ["new", "ai_reviewed", "recruiter_reviewing", "contact_candidate", "screening_scheduled", "submitted_to_client", "interviewing", "offer", "hired", "hold", "not_selected"];

export const CLASSIFICATIONS = ["strong match", "potential match", "transferable-skills match", "insufficient information", "missing mandatory qualification", "human review required"];

export function scoreColor(score) {
  if (score >= 85) return "hsl(var(--gold))";
  if (score >= 65) return "hsl(var(--teal))";
  if (score >= 40) return "hsl(38 70% 50%)";
  return "hsl(0 60% 55%)";
}

export function ScoreRing({ score, size = 56 }) {
  const r = size / 2 - 5;
  const c = 2 * Math.PI * r;
  const off = c - (score / 100) * c;
  return (
    <svg width={size} height={size} className="shrink-0">
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--muted))" strokeWidth="5" />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={scoreColor(score)} strokeWidth="5"
        strokeLinecap="round" strokeDasharray={c} strokeDashoffset={off} className="score-ring"
        transform={`rotate(-90 ${size / 2} ${size / 2})`} />
      <text x="50%" y="52%" textAnchor="middle" dominantBaseline="middle" className="font-head font-bold" style={{ fontSize: size / 3.4, fill: scoreColor(score) }}>{score}</text>
    </svg>
  );
}
